module.exports = __webpack_public_path__ + "img/icon-barcode.8d21a392.svg";